import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface AutoReplyRule {
  rule_id: string;
  type: 'keyword' | 'welcome' | 'away';
  trigger?: string;
  response: { type: 'text' | 'template'; body?: string; template_name?: string; components?: unknown };
  enabled: boolean;
  priority: number;
  schedule?: { active_start?: string; active_end?: string; timezone?: string };
  created_at: number;
  updated_at: number;
}

type QueryResponse = {
  status: number;
  data: {
    rules: AutoReplyRule[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListAutoRepliesKey = (additional: any[] = []) => [
  'list-auto-replies',
  ...additional,
];

export const useListAutoRepliesQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing auto-reply rules',
    endpoint: `/api/admin/whatsapp/auto-replies`,
  });

  return useQuery({
    queryKey: createListAutoRepliesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
